// Who can use the Statement page and Statement History. Mirrors
// STATEMENT_USERS in Server/src/components/efada/efada.routes.js.
export const STATEMENT_USERS = ["admin", "asmaa", "abdelrhman"];
